import React, { useMemo, useState, useEffect } from 'react';
import Select, { SingleValue } from 'react-select';
import countryList from 'react-select-country-list';
import chevDownIcon from 'src/assets/images/icons/chevron-down.svg';
import { companySearchBy } from 'src/enums';
import { CompanySearchParams } from 'src/types';

interface Props {
  search: (searchParams: CompanySearchParams) => void;
  resetResults: () => void;
}

const searchDefaultValues = {
  countryISO: '',
  screening: 'on',
};

function CompanySearchForm(props: Props) {
  const [searchParameters, setSearchParameters] = useState<CompanySearchParams>({
    ...searchDefaultValues,
  });
  const [showStateDropdown, setShowStateDropdown] = useState(false);
  const [countrySelectValue, setCountrySelectValue] = useState('');
  const options: any = useMemo(() => countryList().getData(), []);
  const [searchBy, setSearchBy] = useState<
    companySearchBy.registrationNo | companySearchBy.companyName
  >(companySearchBy.companyName);
  const [stateCode, setStateCode] = useState('');
  const [nameOrRegistration, setNameOrRegistration] = useState('');
  const [btnDisabled, setBtnDisabled] = useState(true);

  const inputValid = () => {
    return nameOrRegistration.length > 0 && countrySelectValue ? true : false;
  };
  const searchDetail = (e: any) => {
    e.preventDefault();
    if (inputValid()) {
      if (searchBy === companySearchBy.companyName) {
        searchParameters.companyName = nameOrRegistration;
        delete searchParameters['companyCode'];
      }

      if (searchBy === companySearchBy.registrationNo) {
        searchParameters.companyCode = nameOrRegistration;
        delete searchParameters['companyName'];
      }

      if (stateCode) {
        searchParameters.stateCode = stateCode;
      }
      props.search(searchParameters);
    }
  };

  useEffect(() => {
    if (inputValid()) {
      setSearchParameters({
        ...searchParameters,
        countryISO: (countrySelectValue as any).value,
      });

      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }

    if ((countrySelectValue as any).value === 'US') {
      setShowStateDropdown(true);
      setStateCode('');
    } else {
      setShowStateDropdown(false);
      setStateCode('');
    }

    props.resetResults();
  }, [nameOrRegistration, countrySelectValue]);

  useEffect(() => {
    setNameOrRegistration('');
    setCountrySelectValue('');
  }, [searchBy]);

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card-title">
          <h4>SEARCH COMPANY</h4>
        </div>
      </div>

      {/*=================================== Company Search Form ==============================*/}
      <div className="col-lg-12">
        <div className="card overflow-visible">
          <form onSubmit={searchDetail}>
            <div className="d-flex gap-3 ew-cols align-items-end flex-wrap">
              <div className="flex-grow-1 ">
                <label className="form-label">Company name or Reg. number*</label>
                <select
                  name="name"
                  required
                  className="form-control"
                  style={{ backgroundImage: `url(${chevDownIcon})` }}
                  onChange={(e) => setSearchBy(e.target.value as companySearchBy)}
                  value={searchBy}
                >
                  <option value={companySearchBy.registrationNo}>Registration No</option>

                  <option value={companySearchBy.companyName}>Company Name</option>
                </select>
              </div>

              <div className="flex-grow-1">
                <label className="form-label">
                  {searchBy === companySearchBy.companyName ? 'Company Name' : 'Registration No'}*
                </label>
                <input
                  name="customer_data"
                  className="form-control"
                  type="text"
                  placeholder={
                    searchBy === companySearchBy.companyName ? 'Company Name' : 'Registration No'
                  }
                  required
                  value={nameOrRegistration}
                  onChange={(e) => {
                    setNameOrRegistration(e.target.value);
                  }}
                />
              </div>
              <div className="flex-grow-1">
                <label className="form-label">Country*</label>
                <Select
                  className="dynamic-countries"
                  name="country"
                  options={options}
                  value={countrySelectValue}
                  onChange={(value: SingleValue<string>) => {
                    setCountrySelectValue(value as any);

                    // setSearchParameters({
                    //   ...searchParameters,
                    //   // country: value,
                    // });
                  }}
                />
              </div>
              {showStateDropdown && (
                <div className="flex-grow-1 ">
                  <label className="form-label">Region</label>
                  <select
                    name="stateCode"
                    className="form-control"
                    style={{ backgroundImage: `url(${chevDownIcon})` }}
                    onChange={(e) => setStateCode(e.target.value)}
                    value={stateCode}
                  >
                    <option value=""></option>
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                  </select>
                </div>
              )}

              <div className="button-group text-right custom-actions">
                <button
                  onClick={() => {
                    setNameOrRegistration('');
                    setCountrySelectValue('');
                    setStateCode('');
                  }}
                  disabled={btnDisabled}
                  type="button"
                  className="button btn-ghost"
                >
                  Clear
                </button>
                <button disabled={btnDisabled} type="submit" className="button btn-with-icon">
                  <img src={require('src/assets/images/icons/search-icon.svg').default} alt="" />
                  Search
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CompanySearchForm;
